import { Loader2 } from 'lucide-react';

/**
 * Componente visual de carga (Spinner).
 * Puedes usarlo en cualquier parte de tu aplicación donde necesites mostrar que algo está cargando.
 */
export function Spinner({ className }: { className?: string }) {
    // Usamos el icono Loader2 de lucide-react y le agregamos la clase 'animate-spin' de Tailwind para que gire
    return <Loader2 className={`animate-spin text-primary ${className || ''}`} />;
}

/**
 * Función de prueba para simular el tiempo que tarda el Backend en responder.
 * Retorna una "Promesa" que se resuelve después de los milisegundos indicados.
 * 
 * Uso: await simulateBackendDelay(2000); // Pausa la ejecución por 2 segundos
 */
export const simulateBackendDelay = (ms: number = 2000) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};